<template>
    <div class="tab-pane" id="gov_sholarship_detail" role="tabpanel" aria-labelledby="gov_sholarship_detail_tab">
        <div class="card">
            <label class="card-header text-center"><strong>Sholarship Details</strong></label>
            <table v-if="admission.length>0" class="table table-bordered table-striped" id="OrgDetails">
                <thead>
                    <tr>
                        <th class="text-center"></th>
                        <th colspan="4" class="text-center">Applied To</th>
                        <th colspan="2" class="text-center">Admission</th>
                    </tr>
                    <tr>
                        <th>S.No</th>
                        <th>Dzongkhag</th>
                        <th>School</th>
                        <th>Class</th>
                        <th>Stream</th>
                        <th>Status</th>
                        <th>Remarks</th>
                        <th>Created At</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in admission" :key="index">
                        <td>{{index + 1}}</td>
                        <td>{{item.dzongkhag}}</td>
                        <td>{{item.organization}}</td>
                        <td>{{item.class}}</td>
                        <td>{{item.stream}}</td>
                        <td>
                            <span v-if="item.status == 0">Pending</span>
                            <span v-else-if="item.status == 1">Not Accepted</span>
                            <span v-else-if="item.status == 2">Accepted</span>
                        </td>
                        <td>
                            <span v-if="item.remarks !=''">
                                {{item.remarks}}
                            </span>
                            <span v-else>
                                You are not admitted
                            </span>
                        </td>
                        <td>
                            {{new Date(item.created_at)}}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-else class="alert alert-warning text-center" role="alert">
                 <strong>You have not applied for government scholarship in the private school</strong> 
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            user_type:'',
            admission:[],
        }
    },
    methods:{
        getStudentApplication(user_id){
            axios.get('admissions/getStudentApplication/'+user_id).then(res =>{
                this.admission = res.data;
            }).catch(error => console.log(error));
        },
    },
    mounted(){
        axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.user_type=data['role'];
            this.getStudentApplication(data['id']);
        })
    }
    
}
</script>